<template>
    <DefaultHeader :noMargin="true" />

    <div :class="{ 'd-none': this.$store.state.hiddenBody }" class="container-fluid page-wrap">

        <div class="dashboard-tabs mb-3">
            <button
                type="button"
                class="dashboard-tab"
                :class="{ active: activeTab === 'overview' }"
                @click="activeTab = 'overview'"
            >
                <span class="tab-dot tab-dot-blue"></span>
                Vue globale
            </button>

            <button
                type="button"
                class="dashboard-tab"
                :class="{ active: activeTab === 'alarms' }"
                @click="activeTab = 'alarms'"
            >
                <span class="tab-dot tab-dot-red"></span>
                Alarmes récentes
            </button>
        </div>

        <OverviewPanel
            v-show="activeTab === 'overview'"
            :clientId="normalizedClientId"
        />

        <AlarmsPanel
            v-show="activeTab === 'alarms'"
            :clientId="normalizedClientId"
        />

    </div>

    <DefaultFooter />
</template>

<script>
import DefaultHeader from "@/components/DefaultHeader.vue";
import DefaultFooter from "@/components/DefaultFooter.vue";
import OverviewPanel from "./sections/OverviewPanel.vue";
import AlarmsPanel from "./sections/AlarmsPanel.vue";

import UserHelper from "@/helpers/user.helper.js";

export default {
    name: "MainDashboard",
    components: {
        DefaultHeader,
        DefaultFooter,
        OverviewPanel,
        AlarmsPanel,
    },
    data() {
        return {
            activeTab: "overview",
        };
    },
    computed: {
        selectedClientId() {
            return UserHelper.getClientId();
        },
        normalizedClientId() {
            return this.selectedClientId ? parseInt(this.selectedClientId, 10) : null;
        },
    },
};
</script>

<style scoped>
.page-wrap {
    padding-top: 12px;
    padding-bottom: 24px;
    padding-left: clamp(12px, 2vw, 32px);
    padding-right: clamp(12px, 2vw, 32px);
}

.dashboard-tabs {
    display: flex;
    gap: 10px;
    padding: 6px;
    border-radius: 16px;
    background: #ffffff;
    border: 1px solid rgba(15, 23, 42, 0.08);
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    overflow-x: auto;
}

.dashboard-tab {
    border: none;
    background: transparent;
    border-radius: 12px;
    padding: 10px 16px;
    font-weight: 600;
    color: #64748b;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
    transition: all 0.2s ease;
}

.dashboard-tab:hover {
    background: rgba(13, 110, 253, 0.06);
    color: #0d6efd;
}

.dashboard-tab.active {
    background: #0d6efd;
    color: #ffffff;
    box-shadow: 0 10px 25px rgba(13, 110, 253, 0.18);
}

.tab-dot {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    display: inline-block;
    flex: 0 0 auto;
}

.tab-dot-blue {
    background: #4f8dfd;
}

.tab-dot-red {
    background: #ef4444;
}

.dashboard-tab.active .tab-dot {
    background: rgba(255, 255, 255, 0.95);
}
</style>